const MEMORY_MARKER = /[ \t]*\[memory:\d+\]/g;
const TRAILING_PARTIAL_MARKER = /[ \t]*\[(m(e(m(o(r(y(:\d*)?)?)?)?)?)?)?$/;

export interface StripMemoryMarkersOptions {
  /** Also drops an unfinished marker at the end of text that is still streaming. */
  streaming?: boolean;
}

/**
 * Removes Scout's `[memory:N]` use markers from reply text; run it on the accumulated text,
 * never per delta, so a marker split across deltas is still caught.
 * @registry Strip `[memory:N]` markers from Scout reply text (render, copy, export).
 */
export const stripMemoryMarkers = (
  text: string,
  {streaming = false}: StripMemoryMarkersOptions = {}
): string => {
  let result = text.replace(MEMORY_MARKER, '');
  if (streaming) result = result.replace(TRAILING_PARTIAL_MARKER, '');
  return result === text ? text : result.trimEnd();
};
